export const HIGH_LEVEL_ROW_BACKGROUND_COLOR = '#bac8d3';

export const COURSE_CLASSIFICATION_ALL_YOU_CAN_EAT = 1;
export const COURSE_CLASSIFICATION_ALL_YOU_CAN_DRINK = 2;
